import { render, staticRenderFns } from "./stringArrayArea.vue?vue&type=template&id=6db36d50&scoped=true&"
import script from "./stringArrayArea.vue?vue&type=script&lang=js&"
export * from "./stringArrayArea.vue?vue&type=script&lang=js&"
import style0 from "./stringArrayArea.vue?vue&type=style&index=0&id=6db36d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db36d50",
  null
  
)

export default component.exports